import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Leaflet requires the CSS to be imported, and the default icon images need
// manual path fixing when bundled with webpack/CRA.
delete L.Icon.Default.prototype._getIconUrl;

const createLibraryIcon = () =>
  L.divIcon({
    html: `<div class="library-pin"><span class="library-pin-inner">📚</span></div>`,
    className: '',
    iconSize: [34, 34],
    iconAnchor: [17, 34],
    popupAnchor: [0, -38],
  });

// Memoised so the icon object isn't recreated on every render
function BranchMarker({ branch, onClick }) {
  const icon = useMemo(() => createLibraryIcon(), []);

  return (
    <Marker
      position={[branch.lat, branch.lng]}
      icon={icon}
      eventHandlers={{ click: onClick }}
    />
  );
}

function LibraryMap({ branches, onBranchClick }) {
  const locatedBranches = branches.filter(b => b.lat != null && b.lng != null);

  return (
    <MapContainer
      center={[51.5074, -0.1278]}
      zoom={11}
      style={{ height: '100%', width: '100%' }}
      zoomControl={false}
    >
      <ZoomControl position="topleft" />
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {locatedBranches.map(branch => (
        <BranchMarker
          key={branch.id}
          branch={branch}
          onClick={() => onBranchClick(branch)}
        />
      ))}
    </MapContainer>
  );
}

export default LibraryMap;
